/* eslint-disable */
/**
 * Hero Carousel
 */
import { Component, registerComponent } from 'js/component.js';
import { gsap } from 'gsap';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin.js';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

const componentName = 'hero-carousel';


export class HeroCarousel extends Component {

    /** Component elements */
    elements = {
    };

    /** Initialize components */
    init() {

        /* GSAP - REGISTER PLUGINS */
        gsap.registerPlugin(MotionPathPlugin);
        gsap.registerPlugin(ScrollTrigger);

        /* GSAP ON WINDOW LOAD */
        window.addEventListener('load', () => {

            /* Elements To Animate - Desktop */
            const heroBlur = document.querySelectorAll('#blur1');
            const heroVectorLeft = document.querySelectorAll('.Hero-Vector-Left');
            const heroVectorRightA = document.querySelectorAll('.hero-vector-right-A');
            const heroVectorRightB = document.querySelectorAll('.Hero-Vector-Right-B');
            const heroVectorRightC = document.querySelectorAll('.Hero-Vector-Right-Container-C');
            const heroVectorOutline = document.querySelectorAll('.Hero-Vector-Outline-Container');
            const heroVectorSolid = document.querySelectorAll('.Hero-Vector-Solid-Container');
            const heroVectorSolid2Path = document.querySelectorAll('.Hero-Vector-Solid-2-Path');
            const heroVectorMiddle = document.querySelectorAll('.Hero-Vector-Middle');
            const heroText = document.querySelectorAll('.new-hero-text');

            /* Elements To Animate - Mobile */
            const mheroVectorLeft = document.querySelectorAll('.m-Hero-Vector-Left-Container');
            const mheroVectorOutline = document.querySelectorAll('.m-Hero-Vector-Outline-Container');
            const mheroVectorSolid = document.querySelectorAll('.m-Hero-Vector-Solid-Container');
            const mheroVectorMiddle = document.querySelectorAll('.m-Hero-Vector-Middle-Container');
            const mheroText = document.querySelectorAll('.new-hero-text');
            const mheroTextInner = document.querySelectorAll('.new-hero-text-inner');
            const mheroBackground = document.querySelectorAll('.m-Hero-Background');
            const mheroImage = document.querySelectorAll('.hero img');

            /* Initiate Timeline - Paused By Default */
            var tl = gsap.timeline({ paused: false });
            var tl2 = gsap.timeline({ paused: false });

            /* Desktop - Timeline Begins Here */
            gsap.to([heroBlur], {motionPath: {path: "#path",align: "#path",alignOrigin: [0.5, 0.5],autoRotate: false},duration: 10,repeat: -1,ease: "none",delay: .1});
            tl.to(heroVectorLeft, {duration: 1, css: { right: '0%' }, ease: "power2.out"}, "0");
            tl.to(heroVectorMiddle, {duration: 1, css: { opacity: '1' }, ease: "power2.out"}, "0");
            tl.to(heroVectorRightA, {duration: 1, css: { opacity: '0' }, attr: { points: " 0 454 377 454 377 300 454 454" }, ease: "power2.out"}, "0");
            tl.to(heroVectorRightB, {duration: 1, css: { opacity: '0' }, ease: "power2.out"}, "0");
            tl.to(heroVectorRightC, {duration: 0.5, opacity: 0.9}, "0");
            tl.to(heroVectorOutline, {duration: 1, delay:.1, css: { bottom: '0px', top: 'calc(100% - 100px)', opacity: '1' }, ease: "back.inOut(1)"}, "0");
            tl.to(heroVectorSolid, {duration: 1, delay:.1, css: { bottom: '0px', top: 'calc(100% - 140px)', opacity: '1' }, ease: "back.inOut(1)"}, "0");
            tl.to(heroVectorSolid2Path, {duration: 1, delay:.1, css: { x: '10px' }, ease: "back.inOut(1)"}, "0");
            tl.to(heroText, {duration: 0.5, css: { opacity: '1', y: '0' }, ease: "back.inOut(1)"}, "0");

            /* Desktop - Scoll Animations */
            gsap.to('.Hero-Vector-Middle', {y: 100,scrollTrigger: {trigger: '.new-hero-wrapper-outer',start: 'top 100px',end: 'bottom top',scrub: true}});
            gsap.to('.Hero-Vector-Solid', {y: -200,scrollTrigger: {trigger: '.new-hero-wrapper-outer',start: 'top 100px',end: 'bottom top',scrub: true}});
            gsap.to('.new-hero .hero img', {scale: 1.15,scrollTrigger: {trigger: '.new-hero-wrapper-outer',start: 'top 100px',end: 'bottom top',scrub: true}});
            gsap.to('.Hero-Vector-Outline-Container', {y: -100,scrollTrigger: {trigger: '.new-hero-wrapper-outer',start: 'top 100px',end: 'bottom top',scrub: true}});
            gsap.to('.Hero-Vector-Solid-Container-2 svg', {y: 200,scrollTrigger: {trigger: '.new-hero-wrapper-outer',start: 'top 100px',end: 'bottom top',scrub: true}});

            /* Mobile - Timeline Begins Here */
            tl2.to(mheroVectorLeft, {duration: .5, delay: .1, css: {height: '100%' },ease: "back.inOut(1)"}, "0");
            tl2.to(mheroVectorMiddle, {duration: .5, delay:.1, css: { opacity: '1', top: '0' }, ease: "power2.out"}, "0");
            tl2.to(mheroVectorOutline, {duration: .5, css: {top: 'calc(100% - 50px)', rotation: '0', scale: '1' }, ease: "back.inOut(1)"}, "0");
            tl2.to(mheroVectorSolid, {duration: .5, delay:.5, css: {top: 'calc(100% - 30px)', left:'-30', opacity: '1' }, ease: "back.inOut(1)"}, "0");
            tl2.to(mheroText, {duration: 1, delay:.5, css: {y: '0' }, ease: "back.inOut(1)"}, "0");
            tl2.to(mheroTextInner, {duration: .5, delay:.5, css: {opacity: '1', y: '0'}, ease: "back.inOut(1)"}, "0");
            tl2.to(mheroBackground, {duration: .5, delay:.5, css: {opacity: '1'}, ease: "back.inOut(1)"}, "0");
            tl2.to(mheroImage, {duration: .5, delay:.5, css: {opacity: '1'}, ease: "back.inOut(1)"}, "0");

            /* Mobile - Scoll Animations */
            gsap.to('.m-Hero-Vector-Middle-Container', {y: 100,scrollTrigger: {trigger: '.new-hero-wrapper-outer',start: 'top 56px',end: 'bottom top',scrub: true}});
            gsap.to('.m-Hero-Vector-Solid', {y: -20,scrollTrigger: {trigger: '.new-hero-wrapper-outer',start: 'top 56px',end: 'bottom top',scrub: true}});
            gsap.to('.m-Hero-Vector-Outline-Container', {y: -20,scrollTrigger: {trigger: '.new-hero-wrapper-outer',start: 'top 56px',end: 'bottom top',scrub: true}});
            gsap.to('.m-Hero-Vector-Left-Container', {x: -150,scrollTrigger: {trigger: '.new-hero-wrapper-outer',start: 'top 56px',end: 'bottom top',scrub: true}});

            /* GSAP - Timeline Functions */
            function reverseTimeline() {tl.reverse(1);}
            function reverseTimeline2() {tl2.reverse(1);}

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', initCarousel);
            } else {
                initCarousel();
            }

            function initCarousel() {

                // Adjust Carousel Height Based on Content
                function adjustCarouselHeight() {
                    let tallestTextContainer = 0;
                    const textContainers = document.querySelectorAll('.new-hero .new-hero-text-inner');

                    textContainers.forEach(container => {
                        const height = container.offsetHeight;
                        tallestTextContainer = Math.max(tallestTextContainer, height);
                    });

                    // [COMPONENT FIT: width > 1268px -> retained hero text-height threshold]
                    const additionalHeight = window.innerWidth > 1268 ? 250 : 450;
                    tallestTextContainer += additionalHeight;

                    const wrapperOuter = document.querySelector('.new-hero-wrapper-outer');
                    if (wrapperOuter) {
                        wrapperOuter.style.height = tallestTextContainer + 'px';
                    }
                }

                adjustCarouselHeight();
                window.addEventListener('resize', adjustCarouselHeight);

                // Clear Transition Delay
                gsap.delayedCall(0.25, () => {
                    const heroWrapper = document.querySelector('.new-hero-wrapper');
                    if (heroWrapper) {
                        heroWrapper.classList.remove('loading');
                    }
                });

                // Variables
                const slider = document.querySelector('.new-hero-wrapper');
                const slides = slider ? Array.from(slider.children) : [];
                let currentIndex = 0;
                const slideCount = slides.length;
                let percentTime;
                let tick;
                const time = 1;
                let progressBarIndex = 0;
                let isPause = false;

                // Initialize carousel
                function showSlide(index) {
                    slides.forEach(slide => slide.classList.remove('slick-active'));
                    if (slides[index]) {
                        slides[index].classList.add('slick-active');
                    }
                }

                window.showSlide = showSlide;

                // Add Button HTML
                const progressBars = document.querySelectorAll('.progressBarContainer .progressBar');
                progressBars.forEach((progressBar, index) => {
                    const progress = `<div class='inProgress inProgress${index}'></div>`;
                    progressBar.innerHTML = progress;
                });

                // Toggle play/pause on button click
                const playPauseBtn = document.querySelector('.play-pause');
                if (playPauseBtn) {
                    playPauseBtn.addEventListener('click', function () {
                        this.classList.toggle('playing');
                        this.classList.toggle('paused');
                        isPause = !isPause;
                    });
                }

                // Start Progress Bar
                function startProgressbar() {
                    resetProgressbar();
                    isPause = false;
                    percentTime = 0;
                    tick = setInterval(interval, 10);
                }

                // Set Interval Time
                function interval() {
                    if (!isPause) {
                        percentTime += 1 / (time + 7);

                        const currentProgress = document.querySelector(`.inProgress${progressBarIndex}`);
                        if (currentProgress) {
                            gsap.set(currentProgress, { width: percentTime + "%" });
                        }

                        const allProgress = document.querySelectorAll('.inProgress');
                        allProgress.forEach(progress => {
                            progress.parentElement.classList.remove('active');
                        });

                        if (currentProgress) {
                            currentProgress.parentElement.classList.add('active');
                        }

                        if (percentTime >= 100) {
                            goToNextSlide();
                            startProgressbar();
                        }
                    }
                }

                // Reset Progress Bar
                function resetProgressbar() {
                    const allProgress = document.querySelectorAll('.inProgress');
                    gsap.set(allProgress, { width: "0%" });
                    clearInterval(tick);
                }

                // Go To Next Slide
                function goToNextSlide() {
                    currentIndex = (currentIndex + 1) % slideCount;
                    showSlide(currentIndex);
                    progressBarIndex = currentIndex;
                    sliderChange();
                }

                // Go To Slide User Selected
                function goToSlide(index) {
                    console.log("SELECTED" + index);
                    currentIndex = index;
                    showSlide(currentIndex);
                    progressBarIndex = currentIndex;
                    sliderChange();
                }

                if (slideCount > 0) {
                    startProgressbar();
                }

                // Slider Navigation Buttons
                const progressButtons = document.querySelectorAll('.progressBarContainer button');
                progressButtons.forEach((button, index) => {
                    button.addEventListener('click', function () {
                        clearInterval(tick);
                        goToSlide(index);
                        startProgressbar();
                        sliderChange();

                        const playPause = document.querySelector('.play-pause');
                        if (playPause) {
                            playPause.classList.add('playing');
                            playPause.classList.remove('paused');
                        }
                    });
                });

                // Slider Animation
                function sliderChange(){
                    gsap.set([tl, tl2], { timeScale: 2 });
                    reverseTimeline();
                    reverseTimeline2();

                    gsap.delayedCall(0.5, () => {
                        gsap.set([tl, tl2], { timeScale: 1 });
                        tl.restart();
                        tl2.restart();
                    });
                }

                function pause() {
                    isPause = true;
                }

                // Expose to window
                window.pause = pause;
                window.goToSlide = goToSlide;
            }

        }); /* End Window Load */

    }
}

registerComponent(`.${componentName}`, HeroCarousel);
